<template>
    <div class="card">
        <div class="card-body" style="padding: 0;">
            <form class="row">
                <div class="col-12">
                    <table class="table-payment-agreement" :key="forceUpdate">
                        <thead>
                            <tr>
                                <th style="font-weight:bold; vertical-align: middle;" colspan="3" >
                                    <div style="display:flex;align-items: center;">
                                        <div class="form-check " style="padding-left: 0;margin-bottom: 0px; margin-right: 15px ;">
                                            <label class="form-check-label" style="">Number of payments:</label>
                                        </div>
                                        <div class="form-check form-check-inline" v-for="(i, index) in numberOfPayments" :key="index" >
                                            <label class="form-check-label" :for="'inlineCheckbox'+i.id">
                                                <input class="form-check-input" type="radio" :id="'inlineCheckbox'+i.id"
                                                name="option" :value="i.id" :checked="i.checked" @change="inputPayments(i, index)">
                                                {{ i.label }}
                                            </label>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                <th style="font-weight:bold;">Description </th>
                                <th style="text-align:center;color:#5ac146;">%</th>
                                <th style="text-align: center;color: #031099;">$</th>
                            </tr>
                        </thead>
                        <tbody >
                            <!-- <tr v-if="payments.length<2">
                                <td style="font-size: 18px;">
                                    Full Payment
                                </td>
                                <td class="text-right" style="font-size: 16px;color:#5ac146;text-align:center;">
                                    <b>100%</b>
                                </td>
                                <td class="text-right" style="font-size: 16px;color:#031099;">
                                    <b>${{ totalData | formatMoney}}</b>
                                </td>
                            </tr> -->
                            <template v-if="payments.length>1">
                                <tr v-for="(payment, idx) in listPayments" :key="idx" :class="[((idx+1)==listPayments.length) ?  'tr-final' : 'tr-'+idx]">
                                    <td>
                                        <input type="text"
                                            :id="'payment-description-'+idx"
                                            :class="['payment']"
                                            v-model="payment.name"
                                            @click="selectInputAllValue"
                                            @mousedown.prevent
                                            @input="changePayment"
                                        />
                                    </td>
                                    <td :class="[((idx+1)==listPayments.length) ?  'no-edit' : '']">
                                        <PercentInput
                                            v-model="payment.percent"
                                            class_input="payment"
                                            style="text-align: center;"
                                            :disabled="inputIsDisabled(idx)"
                                            @input="editPercent(payment, idx)"
                                        />
                                    </td>
                                    <td>
                                        ${{ formatMoney(payment.amount) }}
                                    </td>
                                </tr>
                                <tr >
                                    <td style="font-size: 18px;font-weight:bold;padding-top:15px;">
                                        Total
                                    </td>
                                    <td class="text-center" style="font-size: 16px;font-weight:bold;color:#5ac146;padding-top:15px;">
                                        <b>{{ totalPorcent }}%</b>
                                    </td>
                                    <td class="text-right" style="font-size: 16px;font-weight:bold;color:#031099;padding-top:15px;">
                                        <b>${{ totalAmount | formatMoney }}</b>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import PercentInput from '@/apps/billing/components/estpro/secForm/PercentInputInt.vue';
export default {
    components: {
        PercentInput
    },
    props: {
        propData: {
            type: Object,
            required: false,
            default: () => ({})
        },
        optionsPayments: {
            type: Array,
            required: false,
            default: () => ([])
        },
        formTotal: {
            type: [String, Number],
            required: false,
            default: '0'
        },
        checkState: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            isLoading: false,
            payments: [],
            numberSelected: 0,
            itemSelected: {id: 0},
            timeoutId: null,
            // @ts-ignore
            user_id: window.master_client,
            // @ts-ignore
            org_id: window.localorgdata,
            addNew: null,
            numberOfPayments: [
                // {id: 1, label: '1', checked: true},
                {id: 2, label: '2', checked: false},
                {id: 3, label: '3', checked: false},
                {id: 4, label: '4', checked: false},
            ],
            totalData: 0,
            forceUpdate: 0,
        };
    },
    mounted() {
        this.totalData = this.normalizeTotal(this.formTotal);
        this.optionsPaymentsInit();
    },
    methods: {
        normalizeTotal(value) {
            const total = parseFloat(value);
            return Number.isNaN(total) ? 0 : total;
        },
        inputPayments(i, idx){
            if(this.numberSelected == i.id) {i.checked=true; return false;}
            this.numberOfPayments = this.numberOfPayments.filter(item => {
                item.checked = (i.id == item.id);
                if(item.checked){ this.numberSelected = item.id; }
                return item;
            })
            this.payments= []; // reset del array
            let addItems = i.id;
            for (let index = 0; index < addItems; index++) {
                // ==2 : 50/50
                // ==3 : 50/30/20
                // ==4 : 50/20/15/15
                let percent = 50;
                if(i.id==2 && index>0) {percent = 50;}
                if(i.id==3 && index>0) {percent = 30;}
                if(i.id==3 && index>1) {percent = 20;}
                if(i.id==4 && index==1) {percent = 20;}
                if(i.id==4 && index>1) {percent = 15;}
                let name = ''
                if(index==0){ name = 'Down Payment';}
                else if(index > 0 && (index+1) < addItems) {name = 'Payment '+(this.payments.length+1);}
                else { name = 'Final Payment';}
                const element = {
                    id: (this.payments.length+1),
                    name: name,
                    percent: percent,
                    amount: this.itemAmount(percent)
                };
                // console.log('item '+index, element)
                this.payments.push(element);
            }
            this.forceUpdate++;
            this.changePayment();
        },
        selectInputAllValue(event) {
            setTimeout(() => {
                event.target.select();
            }, 0);
        },
        formatMoney(value) {
            if (typeof value !== 'number') {
                value = parseFloat(value) || 0;
            }
            return value.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        itemAmount(val) {
            const percent = parseInt(val) || 0;
            return (this.normalizeTotal(this.totalData) * percent) / 100;
        },
        inputIsDisabled(idx){
            return (idx+1) == this.payments.length;
        },
        editPercent(item, idx){
            setTimeout(() => {
                // 1. Aseguramos entero
                item.percent = parseInt(item.percent);
                this.payments[idx].amount = this.itemAmount(item.percent);
                // 2. Obtener sumatoria de los items hasta el editado
                let used = 0;
                for (let i = 0; i <= idx; i++) {
                    used += parseInt(this.payments[i].percent);
                }

                // 3. Calcular cuanto queda para repartir
                let restantes = this.payments.length - (idx + 1);
                let sobrante = 100 - used;

                if (sobrante < 0) sobrante = 0;

                // 4. Calcular percent entero base
                let base = Math.floor(sobrante / restantes);

                // 5. Sobrante que queda tras el floor
                let diff = sobrante - (base * restantes);

                // 6. Asignar el nuevo percent a cada item siguiente
                for (let i = idx + 1; i < this.payments.length; i++) {
                    this.payments[i].percent = base;
                    this.payments[i].amount = this.itemAmount(base);

                    // Distribuir 1 extra a los primeros "diff" items
                    if (diff > 0) {
                        this.payments[i].percent += 1;
                        this.payments[i].amount = this.itemAmount(this.payments[i].percent);
                        diff--;
                    }
                }

                // Forzar actualización en Vue 2
                this.forceUpdate++;
                this.changePayment();
            }, 500);
        },
        changePayment() {
            setTimeout(() => {
                this.$emit('update:paymentAgreement', this.payments);
            }, 500);
        },
        updateTotal(){
            for (let index = 0; index < this.payments.length; index++) {
                if(this.payments[index]){
                    this.payments[index].amount = this.itemAmount(this.payments[index].percent)
                }
            }
            this.forceUpdate++;
            this.changePayment();
        },
        optionsPaymentsInit(){
            console.log('optionsPayments', this.optionsPayments)
            if(this.optionsPayments && this.optionsPayments.length > 0){
                this.payments = JSON.parse(JSON.stringify(this.optionsPayments));
                // Ajustar numberOfPayments
                let numPay = this.payments.length;
                this.numberOfPayments = this.numberOfPayments.filter(item => {
                    item.checked = (numPay == item.id);
                    if(item.checked){ this.numberSelected = item.id; }
                    return item;
                });
            }
            if(this.payments.length==0){
                this.ifCheckedStateTrue();
            }
        },
        ifCheckedStateTrue() {
            if(this.payments.length == 0) {
                this.inputPayments({id: 2}, 0);
            }
        }
    },
    watch: {
        "formTotal": function(newVal) {
            this.totalData = this.normalizeTotal(newVal);
            this.updateTotal();
        },
        optionsPayments: function() {
            // console.log('watch optionsPayments', this.optionsPayments)
            this.optionsPaymentsInit();
        },
        checkState: function(_newVal){
            // this.ifCheckedStateTrue();
        },
    },
    computed: {
        totalPorcent: function(){
            let total = 0;
            for (let index = 0; index < this.payments.length; index++) {
                if(this.payments[index]){
                    // total += parseFloat(this.payments[index].percent);
                    total += parseInt(this.payments[index].percent);
                }
            }
            // return total > 100 ? 100 : total;
            return total;
        },
        totalAmount: function(){
            let total = 0;
            for (let index = 0; index < this.payments.length; index++) {
                if(this.payments[index]){
                    total += parseFloat(this.payments[index].amount);
                }
            }
            // return total > this.totalData ? this.totalData : total;
            return total;
        },
        listPayments: function(){
            return this.payments
        },
    },
}
</script>
<style lang="scss" scoped>
.form-check.form-check-inline:hover label{
    font-size: 1.1em;
}
.form-check.form-check-inline input[type=radio], .form-check.form-check-inline label {
    cursor: pointer;
}
table.table-payment-agreement {
    width: 100%;
    margin-bottom: 20px;
}

table.table-payment-agreement thead tr th {
    font-weight: normal;
    color: #555;
    font-size: 1em;
    line-height: 1em;
    padding: 5px;
    border-bottom: 1px solid #ddd;
}

table.table-payment-agreement thead tr th.subtotal {
    font-size: 1.5em;
    font-weight: bold;
    text-align: right;
    color: #031099;
}

table.table-payment-agreement thead tr th:nth-child(3) {
    text-align: right;
    font-weight: bold;
    color: #000;
}

table.table-payment-agreement tbody tr td {
    font-weight: normal;
    color: #777;
    font-size: 0.9em;
    line-height: 1em;
    padding: 5px;
}

input.payment {
    width: 100%;
    height: 20px;
    border: none;
    background: transparent;
    color: #555;
    font-size: 1em;
    line-height: 1em;
    padding: 5px;
    margin: 0;
}

table.table-payment-agreement tbody tr td:nth-child(2) {
    width: 70px;
    min-width: 70px;
    max-width: 70px;
}

table.table-payment-agreement tbody tr td:nth-child(3) {
    width: 100px;
    min-width: 100px;
    max-width: 100px;
    text-align: right;
}

table.table-payment-agreement tfoot tr td:nth-child(1) {
    text-align: right;
    font-weight: bold;
    font-size: 2em;
    color: #555;
    border-top: 1px solid #ddd;
}

table.table-payment-agreement tfoot tr td:nth-child(2) {
    width: 100px;
    min-width: 100px;
    max-width: 100px;
    text-align: right;
    font-weight: bold;
    font-size: 2em;
    color: #031099;
    border-top: 1px solid #ddd;
}

table.table-payment-agreement tbody tr:hover td {
    background-color: #e1f5fe;
}

table.table-payment-agreement tbody tr:hover td input {
    color: #000 !important;
}

table.table-payment-agreement tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
}

table.table-payment-agreement tbody tr:nth-of-type(even) {
    background-color: #fafafa;
}

table.table-payment-agreement td input:hover,
table.table-payment-agreement td input:focus {
    background-color: #fff !important;
}

table.table-payment-agreement td.no-edit input:hover,
table.table-payment-agreement td.no-edit input:focus {
    background-color: #e1f5fe !important;
}
table.table-payment-agreement tr.tr-final td.no-edit {
    position: relative;
}
table.table-payment-agreement tr.tr-final td.no-edit:before {
    content: "Auto-calculated";
    font-style: italic;
    color: #999;
    font-size: 0.8em;
    line-height: 1;
    text-align: right;
    position: absolute;
    bottom: 10px;
    left: -60px;
    width:100%;
}
.form-check.form-check-inline .form-check-label {
    padding: 5px 8px 5px 5px;
    background: #ddd;
    border-radius: 4px;
    line-height: 1;
    display:flex;
    align-items: center;
}
</style>
